import React from 'react';
import { Col, Divider, Row } from 'antd';
import { useTranslation } from 'react-i18next';
const CustomTooltip = props => {
  const { t } = useTranslation();
  if (props?.payload?.[0]) {
    return (
      <div className="recharts-default-tooltip" style={{ width: 320 }}>
        <Row gutter={[0, 4]}>
          {props.payload.map(record => {
            const pdValue =
              (record?.name === 'bankruptcyRatingClass' && record?.payload?.bankruptcyPd) ||
              (record?.name === 'defaultRatingClass' && record?.payload?.defaultPd);
            const formattedValue = props.valueTranslator(record.name, record.value, pdValue.toFixed(3));
            return (
              <React.Fragment key={record.name}>
                <Col className="chart-record-value justify-content-center" span={24} style={{ color: record.color }}>
                  {formattedValue}
                </Col>
                <Col span={24} className="chart-record-name justify-content-center">
                  {props.nameTranslation(record.name)}
                </Col>
              </React.Fragment>
            );
          })}
          <Divider style={{ margin: '4px 0' }} />
          <Col span={24} className="chart-record-label justify-content-center">
            {props?.label} - {t('graph.ratingScoringHistory.explanation')}
          </Col>
        </Row>
      </div>
    );
  }
  const mapLatestValueToSeries = (latestRecord, series) => {
    const date = latestRecord.dateFrom ?? latestRecord.date ?? latestRecord.month ?? latestRecord.yearQuarter;
    return series
      .map(({ dataKey, fill, stroke, color, dataKey2 }) => {
        if (dataKey in latestRecord) {
          return {
            date,
            value: latestRecord[dataKey],
            value2: latestRecord[dataKey2],
            name: dataKey,
            color: fill ?? stroke ?? color,
          };
        }
        return null;
      })
      .filter(Boolean);
  };
  const latestValues = mapLatestValueToSeries(props.latestRecord, props.series);
  return (
    <div className="recharts-default-tooltip" style={{ width: 320 }}>
      <Row gutter={[0, 4]}>
        {latestValues.map(record => (
          <React.Fragment key={record.name}>
            <Col className="chart-record-value justify-content-center" span={24} style={{ color: record.color }}>
              {props.valueTranslator(record.name, record.value, record.value2.toFixed(3))}
            </Col>
            <Col span={24} className="chart-record-name justify-content-center">
              {props.nameTranslation(record.name)}
            </Col>
          </React.Fragment>
        ))}
        <Divider style={{ margin: '4px 0' }} />
        <Col span={24} className="chart-record-label justify-content-center">
          {latestValues[0]?.date} - {t('graph.ratingScoringHistory.explanation')}
        </Col>
      </Row>
    </div>
  );
};
export default CustomTooltip;
